/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Delete } from '../fn/ticket-status/delete';
import { Delete$Params } from '../fn/ticket-status/delete';
import { Get } from '../fn/ticket-status/get';
import { Get$Params } from '../fn/ticket-status/get';
import { List } from '../fn/ticket-status/list';
import { List$Params } from '../fn/ticket-status/list';
import { Save } from '../fn/ticket-status/save';
import { Save$Params } from '../fn/ticket-status/save';
import { SupportTicketStatusModel } from '../models/support-ticket-status-model';
import { SupportTicketStatusViewModelPrimeDatatableResults } from '../models/support-ticket-status-view-model-prime-datatable-results';

@Injectable({ providedIn: 'root' })
export class TicketStatusApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTicketStatusListPost()` */
  static readonly ApiTicketStatusListPostPath = '/api/TicketStatus/List';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<SupportTicketStatusViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketStatusViewModelPrimeDatatableResults>): SupportTicketStatusViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusGetPost()` */
  static readonly ApiTicketStatusGetPostPath = '/api/TicketStatus/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<SupportTicketStatusModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketStatusModel>): SupportTicketStatusModel => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusSavePost()` */
  static readonly ApiTicketStatusSavePostPath = '/api/TicketStatus/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<SupportTicketStatusModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketStatusModel>): SupportTicketStatusModel => r.body)
    );
  }

  /** Path part for operation `apiTicketStatusDeletePost()` */
  static readonly ApiTicketStatusDeletePostPath = '/api/TicketStatus/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Delete()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete$Response(params?: Delete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Delete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Delete$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Delete(params?: Delete$Params, context?: HttpContext): Observable<void> {
    return this.Delete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
